var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"mask"}),_vm._v(" "),_c('div',{staticClass:"body"},[_vm._t("default",[_vm._t("header",[_c('div',{staticClass:"header",domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_vm._t("body")])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52a1444c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal/index.vue
// module id = null
// module chunks = 